import { createSlice } from "@reduxjs/toolkit";
import * as Settings from "../../settings/Settings";
import axios from "axios";
const apiurl = Settings.ApiEndPoint;
export const counterSlice = createSlice({
  name: "counter",
  initialState: {
    value: 0,
    sampleRecords: [],
  },
  reducers: {
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
    getAllSampleRecords: (state, action) => {
      state.sampleRecords = [];
      action.payload.forEach((item) => {
        state.sampleRecords.push(item);
      });
    },
  },
});

export const {
  increment,
  decrement,
  incrementByAmount,
  getAllSampleRecords,
} = counterSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const incrementAsync = (amount) => (dispatch) => {
  setTimeout(() => {
    dispatch(incrementByAmount(amount));
  }, 1000);
};

export const getAllAsync = () => (dispatch) => {
  axios.get(`${apiurl}api/Sample`).then((res) => {
    console.log(res);
    dispatch(getAllSampleRecords(res.data));
  });
};

export const SaveForm = (data) => (dispatch) => {
  axios.post(`${apiurl}api/Sample`, data).then((res) => {
    console.log(res);
    dispatch(getAllAsync());
  });
};

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectCount = (state) => state.counter.value;

export default counterSlice.reducer;
